import { Button, Input } from "reactstrap";
import * as Ionicons from "react-icons/io";
import { useState } from "react";

const EditInfoInput = ({
  editState,
  setEditState,
  targetItem,
  updatedOrgProfile,
  mutationVariables,
  value,
  mutatinValiablesKey,
  placeholder,
  type,
}) => {
  const SyncIcon = Ionicons["IoIosSync"];
  const CloseIcon = Ionicons["IoMdClose"];

  const [val, setVal] = useState(value);

  const chengeEditStatus = () => {
    let newEditStatus = { ...editState };
    newEditStatus[targetItem] = !editState[targetItem];
    setEditState(newEditStatus);
  };

  const updateMutation = () => {
    mutationVariables[mutatinValiablesKey] =
      val === "" ? (type === "number" ? 0 : "-") : val;
    updatedOrgProfile(mutationVariables);
    chengeEditStatus();
  };

  return (
    <div className="flex-ai-center">
      <Input
        className="form-control mb-0"
        placeholder={placeholder ?? val}
        minRows={1}
        maxRows={1}
        style={{ width: "60%" }}
        value={val}
        onChange={(e) => {
          setVal(e.target.value);
        }}
      />
      <Button
        className="ema__btn__update"
        onClick={() => {
          updateMutation();
        }}
      >
        <SyncIcon fontSize="18px" style={{ marginRight: 4 }} /> 更新
      </Button>
      <Button onClick={chengeEditStatus} style={{ padding: "0.3rem 8px" }}>
        <CloseIcon fontSize="16px" className="pointer" />
      </Button>
    </div>
  );
};

export default EditInfoInput;
